// External dependencies
import React from 'react';
// WordPress dependencies
import { Component } from '@wordpress/element';
import { Spinner } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
// Internal dependencies
import Tabs from './Tabs';

class EditPost extends Component {
	constructor( props ) {
		super( props );

		this.defaultColorProps = {
			hex: '',
			rgb: {},
			hsv: {},
			hsl: {},
			source: 'hex',
			oldHue: 0,
		};

		this.defaultPaddingProps = {
			top: '0',
			right: '20px',
			bottom: '0',
			left: '20px',
		};

		this.state = {
			is_mounted: false,
			post_id: document.querySelector( '#post_ID' ).value,
			active_tab: 'content',
			slider_type: 'default',
			before_after_panel_open: true,
			indicator_panel_open: false,
			settings_panel_open: false,
			overlay_panel_open: true,
			handle_panel_open: false,
			divider_panel_open: false,
			label_panel_open: false,
			before_image: '',
			middle_image: '',
			after_image: '',
			indicator_image: '',
			image_size: 'full',
			before_image_label: __( 'Before', 'wp-before-after-image-slider' ),
			middle_image_label: __( 'Middle', 'wp-before-after-image-slider' ),
			after_image_label: __( 'After', 'wp-before-after-image-slider' ),
			// Video-related attributes
			// video_before_type: 'youtube',
			// video_after_type: 'youtube',
			video_source_type: 'youtube',
			video_before_youtube: '',
			video_after_youtube: '',
			video_before_file: {},
			video_after_file: {},
			video_before_label: __( 'Before', 'wp-before-after-image-slider' ),
			video_after_label: __( 'After', 'wp-before-after-image-slider' ),
			// Video time attributes
			video_before_start_time: 0,
			video_before_end_time: 0,
			video_after_start_time: 0,
			video_after_end_time: 0,
			video_before_upload_start_time: 0,
			video_before_upload_end_time: 0,
			video_after_upload_start_time: 0,
			video_after_upload_end_time: 0,
			// Video control attributes
			video_loop: false,
			video_autoplay: false,
			// Retouch slider attributes
			retouch_image: '',
			retouch_filter: 'grayscale',
			retouch_intensity: 100,
			retouch_apply_on: 'after',
			// Other attributes
			default_offset: 50,
			trigger_type: 'drag',
			orientation: 'horizontal',
			show_overlay: true,
			show_labels: 'label_always_show',
			slider_template: 'default',
			show_popup: false,
			popup_position: 'bottom-right',
			overlay_color_normal: this.defaultColorProps,
			overlay_color_hover: this.defaultColorProps,
			handle_icon_color_normal: this.defaultColorProps,
			handle_icon_color_hover: this.defaultColorProps,
			handle_background_color_normal: this.defaultColorProps,
			handle_background_color_hover: this.defaultColorProps,
			handle_border_style: 'solid',
			handle_border_width: '3px',
			handle_border_color_normal: this.defaultColorProps,
			handle_border_color_hover: this.defaultColorProps,
			divider_color_normal: this.defaultColorProps,
			divider_width: '3px',
			label_horizontal_alignment: 'middle',
			label_vertical_alignment: 'middle',
			label_alignment: 0,
			label_text_color_before: this.defaultColorProps,
			label_text_color_middle: this.defaultColorProps,
			label_text_color_after: this.defaultColorProps,
			label_background_color_before: this.defaultColorProps,
			label_background_color_middle: this.defaultColorProps,
			label_background_color_after: this.defaultColorProps,
			label_border_style: 'none',
			label_border_width: '2px',
			label_border_color_normal: this.defaultColorProps,
			label_padding: null,
			diagonal_direction: 'backslash',
			// Badge / Watermark
			badge_enabled: null,
			customToggles: {},
		};

		this.proFeatures = [
			'indicator_image',
			'default_offset',
			'slider_template',
			'show_popup',
			'popup_position',
			'auto_slide_enabled',
			'triple_auto_slide_enabled',
			'overlay_color_normal',
			'overlay_color_hover',
			'overlay_gradient_normal',
			'overlay_gradient_hover',
			'handle_icon_color_normal',
			'handle_icon_color_hover',
			'handle_background_color_normal',
			'handle_background_color_hover',
			'handle_background_gradient_normal',
			'handle_background_gradient_hover',
			'handle_border_style',
			'handle_border_width',
			'handle_border_color_normal',
			'handle_border_color_hover',
			'divider_color_normal',
			'divider_width',
			'label_horizontal_alignment',
			'label_vertical_alignment',
			'label_alignment',
			'label_text_color_normal',
			'label_text_color_hover',
			'label_background_color_normal',
			'label_background_color_hover',
			'label_border_color_normal',
			'label_border_color_hover',
			'label_padding',
			'diagonal_direction',
			'badge_enabled',
		];

		this.defaultProSettings = {
			is_pro_active: false,
			is_triple_active: false,
		};
		this.proSettings = window.COCA_BAIS_PRO || this.defaultProSettings;
		this.buyNowUrl = 'https://codecanel.com/wp-before-after-image-slider/';
		this.handleUpdateAttributes = this.handleUpdateAttributes.bind( this );
	}

	componentDidMount() {
		// clean local cache
		window.localStorage.removeItem( 'coca_bais_data' );
		// data from database
		const savedMetadata = window.COCA_BAIS_META_DATA || {};
		this.setState( ( prevState ) => ( {
			...prevState,
			...savedMetadata,
			is_mounted: true,
		} ) );
	}

	// Update all attributes
	handleUpdateAttributes( attributes ) {
		// First update the state
		this.setState( ( prevState ) => {
			const newState = {
				...prevState,
				...attributes,
			};
			
			// Then update localStorage with the complete updated state
			window.localStorage.setItem(
				'coca_bais_data',
				JSON.stringify( newState )
			);
			
			// Debug: Verify what was saved to localStorage
			const savedData = window.localStorage.getItem('coca_bais_data');
			return newState;
		} );
	}

	render() {
		if ( this.state.is_mounted ) {
			return (
				<div className={ 'panel-wrapper' }>
					<Tabs
						updateAttributes={ this.handleUpdateAttributes }
						attributes={ this.state }
						proSettings={ this.proSettings }
						proFeatureEnabled={ this.proSettings.is_pro_active }
						proFeatures={ this.proFeatures }
						buyPro={ this.buyNowUrl }
					/>
				</div>
			);
		}

		return <Spinner />;
	}
}

export default EditPost;
